
//XXX cf moving more code in here?

export type TextResizeMode = '' | 'textWidth' | 'fieldWidth' | 'textCorner';

export class ResizeMode
{
	private theMode: TextResizeMode = '';

	mode() { return this.theMode; }

//TODO cf replacing with setTextWidth(), clear() etc...
	setMode(mode:TextResizeMode) { this.theMode = mode; }
}

